import React from "react";
import tw from "tailwind-styled-components";
import { useFormik } from "formik";
import Loading from "../Loading";
import { InputGroup, Label, SubmitBtn } from "../Styles/InputStyles";
import Model from "../Model";
import * as Yup from "yup";
import { toast } from "react-toastify";
import Config from "../../Config";

const EditDuesModel = ({
  editDuesMutate,
  editEntryLoading,
  setEditDues,
  selectedData,
}) => {
  const SubmitHandler = (values) => {
    if (!values.balance) {
      toast.error("Please enter due balance");
      return;
    }
    editDuesMutate(values);
  };

  const formik = useFormik({
    initialValues: {
      id: selectedData?.id || "",
      balance: selectedData?.balance || "",
      type: selectedData?.type || "",
      tenantId: selectedData?.tenantId || "",
      ledgerReferenceId: selectedData?.ledgerReferenceId || "",
      clientId: selectedData?.clientId || "",
    },

    onSubmit: SubmitHandler,
    enableReinitialize: true,
  });

  return (
    <Model width={`w-11/12 max-w-md`} setOpenModel={setEditDues}>
      {editEntryLoading ? (
        <div className="w-full h-full">
          <Loading />
        </div>
      ) : (
        <Wrapper>
          <Title>Edit Dues</Title>
          <form onSubmit={formik.handleSubmit}>
            <Wrapper>
              <InputGroup>
                <Label htmlFor="balance">Balance</Label>
                <FieldWrapper>
                  <Input
                    type="text"
                    name="balance"
                    id="balance"
                    autoComplete="off"
                    className="truncate"
                    required
                    value={formik.values.balance}
                    onChange={(e) => {
                      const value = e.target.value.replace(/[^0-9]/g, "");
                      if (value.length <= 7) {
                        // Limits the length to 7 digits
                        formik.setFieldValue("balance", value);
                      }
                    }}
                  />

                </FieldWrapper>
              </InputGroup>

            </Wrapper>

            <BtnWrapper>
              <SubmitBtn type="submit">Update</SubmitBtn>
            </BtnWrapper>
          </form>
        </Wrapper>
      )}
    </Model>
  );
};

const Wrapper = tw.div`px-1  space-y-4`;
const FieldWrapper = tw.div`w-full`;
const Title = tw.h2`text-lg md:text-xl lg:text-2xl text-gray-600 font-medium mb-6 text-center`;
const BtnWrapper = tw.div`w-full flex items-center justify-center space-x-10 mt-8`;
const Input = tw.input`truncate border border-gray-300 border-m rounded pl-2 focus:ring-1 focus:ring-sky-600 focus:border-sky-600 focus:outline-none duration-200`;

export default EditDuesModel;
